import React from 'react'
import { useSelector } from 'react-redux'
import CommentIcon from '../../../../../components/commentSection/commentIcon/CommentIcon.component'
import { getDrainsAndTubesSelector } from '../selectors'
import { DrainsAndTubesConstants } from '../store/drainsAndTubes.constants'
import { TabConstants } from '../../../../../components/tabs/Tabs.constants'

export const DrainsAndTubesComment = () => {
  const drainsAndTubes = useSelector(getDrainsAndTubesSelector)
  return (
    <CommentIcon
      className='comments'
      commentPageTitle='Drains and Tubes Comments'
      commentText={drainsAndTubes.comments}
      commentMaxLength={250}
      previousPagePath={TabConstants.BODY_ASSESSMENT}
      onChangeAction={[DrainsAndTubesConstants.SET_COMMENTS_OTHER, 'comments']}
      saveAction={[DrainsAndTubesConstants.SAVE_DRAINS_AND_TUBES]}
      validationAction={DrainsAndTubesConstants.SET_COMMENTS_OTHER}
    />
  )
}
